import links from "@constants/links";
import { Box, Button, CardContent, CardHeader, Typography } from "@mui/material";

interface OtherCredentialsVerificationProps {
  title?: string;
}

export default function OtherCredentialsVerification({ title = "2.1 Verify professional credentials" }: OtherCredentialsVerificationProps) {
  return (
    <Box>
      <CardHeader
        title={title}
        slotProps={{ title: { variant: "h5" } }}
      />
      <CardContent>
        <Typography gutterBottom sx={{ mb: 3 }}>
          Thank you for your interest. Based on your selection, we need to verify your professional
          credentials.
        </Typography>

        <Typography gutterBottom sx={{ mb: 3 }}>
          Please click the link below to complete our Provider Application for Exception.
        </Typography>

        <Typography gutterBottom sx={{ mb: 3 }}>
          You will be notified of the status of your application within 5 business days following
          submission.
        </Typography>
        <Button href={links.professionalCredentials.applicationForm} variant="contained">
          Application For Exception
        </Button>
      </CardContent>
    </Box>
  );
}
